"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core/");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const langLevels = [
    {
        id: 1,
        name: "Certified"
    },
    {
        id: 2,
        name: "Professionally qualified"
    },
    {
        id: 3,
        name: "Language skilled"
    }
];
const ExpertLanguages = (props) => {
    const { open, services, editableLanguage, expert } = props;
    let languages = services
        .filter(s => s.isLang)
        .filter(s => { var _a; return !((_a = expert === null || expert === void 0 ? void 0 : expert.languages) === null || _a === void 0 ? void 0 : _a.find(l => l.name === s.name && !l.deleted)); });
    const { name = '', cert = '', level = '' } = editableLanguage === null || editableLanguage === void 0 ? void 0 : editableLanguage.lang;
    const lang = Object.assign({ name,
        cert,
        level }, editableLanguage === null || editableLanguage === void 0 ? void 0 : editableLanguage.lang);
    const [language, updateLanguage] = react_1.default.useState(lang);
    const init = () => {
        updateLanguage(lang);
    };
    const save = () => {
        const langs = (expert.languages || []).slice();
        const index = editableLanguage.index;
        const langLevel = langLevels.find(l => l.id === language.level);
        if (index >= 0 && typeof index === 'number') {
            langs[index] = Object.assign(Object.assign({}, language), { levelName: langLevel === null || langLevel === void 0 ? void 0 : langLevel.name, edited: true });
        }
        else {
            langs.push(Object.assign(Object.assign({}, language), { levelName: langLevel === null || langLevel === void 0 ? void 0 : langLevel.name, added: true }));
        }
        props.editExpert({ key: 'languages', val: langs });
        closeModal();
    };
    const add = (val, key) => {
        let edited = Object.assign({}, language);
        if (key === 'lang') {
            edited.name = val.name;
            edited.lang_id = val.id;
        }
        else {
            edited[key] = val;
        }
        updateLanguage(edited);
    };
    const del = () => {
        const index = expert.languages.findIndex(l => l.id === editableLanguage.lang.id);
        const langs = expert.languages.slice();
        langs[index] = Object.assign(Object.assign({}, language), { deleted: true });
        props.editExpert({ key: 'languages', val: langs });
        closeModal();
    };
    const closeModal = () => {
        props.editLanguage({ index: false, lang: {} });
        props.triggerModal({
            key: 'experts.languages',
            val: false
        });
    };
    const editMode = ((editableLanguage === null || editableLanguage === void 0 ? void 0 : editableLanguage.lang) && Object.keys(editableLanguage === null || editableLanguage === void 0 ? void 0 : editableLanguage.lang).length);
    return open && (react_1.default.createElement(core_1.Dialog, { open: open, className: "language-modal", maxWidth: 'sm', fullWidth: true, onEnter: () => init(), onClose: () => closeModal() },
        react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.DialogTitle, { id: "form-dialog-title" },
                editMode ? 'Edit' : 'Add',
                " Language"),
            react_1.default.createElement(core_1.DialogContent, { className: "lang-content-body" },
                (languages && languages.length) && react_1.default.createElement(Autocomplete_1.default, { id: "languages", freeSolo: true, value: language, options: languages, onChange: (e, v) => add(v, 'lang'), getOptionLabel: (option) => option.name, renderInput: (params) => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: "Languages", margin: "normal", variant: "outlined" }))) }),
                react_1.default.createElement(core_1.FormControl, { variant: "outlined", className: "lang-form" },
                    react_1.default.createElement(core_1.InputLabel, { id: "select-service" }, "Proficiency Level"),
                    react_1.default.createElement(core_1.Select, { labelId: "select-service", id: "select-service-outlined", className: "choose-lang", value: language.level, onChange: (e) => {
                            add(e.target.value, 'level');
                        }, label: "Proficiency Level" },
                        react_1.default.createElement(core_1.MenuItem, { value: "" },
                            react_1.default.createElement("em", null, "None")),
                        langLevels.map((val, key) => react_1.default.createElement(core_1.MenuItem, { key: key, value: val.id }, val.name)))),
                react_1.default.createElement(core_1.TextField, { variant: "outlined", value: language.cert, onChange: (e) => add(e.target.value, 'cert'), margin: "dense", label: 'Certificate N', type: "text", fullWidth: true })),
            react_1.default.createElement("div", { className: "modal-bottom" },
                editMode &&
                    react_1.default.createElement("div", { className: " profile-action-box" },
                        react_1.default.createElement(core_1.Button, { onClick: () => del(), disableRipple: true, className: "profile-delete" }, "Delete")) || react_1.default.createElement("div", null),
                react_1.default.createElement(core_1.DialogActions, { className: 'btn-group expert-modal-footer-button-group' },
                    react_1.default.createElement(core_1.Button, { color: "primary", className: 'dialog-actions', onClick: () => save() }, "Save"),
                    react_1.default.createElement(core_1.Button, { className: 'dialog-actions', onClick: () => closeModal(), color: "secondary" }, "Never Mind"))))));
};
const mapStateToProps = (state) => {
    const { modals, experts } = state;
    return {
        open: modals.ADMIN.experts.languages,
        expert: experts.editableExpert,
        services: experts.mergeServices,
        editableLanguage: experts.editableLanguage
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        submit: () => dispatch(expertsSlice_1.submit()),
        editLanguage: (data) => dispatch(expertsSlice_1.editLanguage(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertLanguages);
